/* eslint-disable */
import {
  mdiViewDashboard,
  mdiAccountAlert,
  mdiBusDoubleDecker,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiFaceAgent,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiSchool,
  mdiBookOpenVariant,
  mdiBookshelf,
  mdiBookOpenPageVariant,
  mdiBookPlusMultiple,
  mdiHammerScrewdriver,
  mdiFormatListBulletedType,
  mdiFormatLetterMatches,
  mdiNumeric9BoxMultiple,
  mdiNotebookEdit,
  mdiAccountDetails,
  mdiTimetable,
  mdiCalendarMonth,
  mdiTimelineClockOutline,
  mdiPuzzle,
  mdiConsoleNetworkOutline,
  mdiSoccer,
  mdiClipboardAccount,
  mdiClipboardAccountOutline,
  mdiQrcodeScan,
  mdiRunFast,
  mdiTrophyOutline,
  mdiClipboardText 
} from "@mdi/js";
// const roles = localStorage.getItem('roles')
const menuHeadMaster = [
  {
    to: "/comboard-dashboard",
    icon: mdiViewDashboard,
    label: "sidebar.dashboard",
  },
  {
    label: "Student",
    subLabel: "Submenus Student",
    icon: mdiAccountCircle,
    menu: [
      {
        to: "/students",
        label: "Students Data",
        icon: mdiAccountGroup,
      },
      {
        to: '/non-academic-activity',
        label: 'Non-Academic Activities',
        icon: mdiRunFast
      },
      {
        label: 'Student Achievement',
        to: '/student-achievement',
        icon: mdiTrophyOutline
      }
      // {
      // 	to: '/student-doc',
      // 	label: 'Student Documents',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/parentuser',
      // 	label: 'Parents',
      // 	icon: mdiAccount
      // },
      // {
      // 	to: '/',
      // 	label: 'Users',
      // 	icon: mdiAccountMultiple
      // },
      // {
      // 	to: '/class-transfer',
      // 	label: 'Class Transfer',
      // 	icon: mdiAccountMultiplePlus
      // },
      // {
      // 	to: '/student-resignation',
      // 	label: 'Resignation',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/graduation',
      // 	label: 'Graduation',
      // 	icon: mdiAccountSchool
      // }
    ],
  },
  {
    label: "Permission Request",
    subLabel: "Submenus Teacher",
    icon: mdiFaceAgent,
    menu: [
      {
        to: "/permissions",
        label: "Permissions",
        icon: mdiFaceAgent,
      },
      {
        to: "/permission-reason",
        label: "Permission Reason",
        icon: mdiFaceAgent,
      },
    ],
  },
  {
    label: "Attendance",
    subLabel: "Submenus Attendance",
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: "/daily-attendance",
        label: "Daily Attendance",
        icon: mdiConsoleNetworkOutline,
      },
      {
        to: "/regular-subject-attendance",
        label: "Regular Subject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/parallel-subject",
        label: "Parallel Subject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/report-attendance-daily",
        label: "Daily Attendance Report",
        icon: mdiAccountAlert,
      },
      {
        to: "/assignment-special",
        label: "Special Assignment",
        icon: mdiBusDoubleDecker,
      },
    ],
  },
  {
    label: "Schedule",
    subLabel: "Submenus Schedule",
    icon: mdiTimetable,
    menu: [
      // 	{
      // 	to: '/schooltime',
      // 	label: 'School Time',
      // 	icon: mdiAvTimer
      // },
      // {
      // 	to: '/studytime',
      // 	label: 'Study Time',
      // 	icon: mdiAvTimer
      // },
      {
        to: "/schedule",
        label: "Schedule",
        icon: mdiTimetable,
      },
      {
        to: "/extracuricular-schedule",
        label: "Extracuricular Schedule",
        icon: mdiTimetable,
      },
      {
        to: "/calendar",
        label: "Calendar",
        icon: mdiCalendarMonth,
      },
    ],
  },
  {
    label: "Subject",
    subLabel: "Submenus Subject",
    icon: mdiBookOpenVariant,
    menu: [
      {
        to: "/subject",
        label: "Subject",
        icon: mdiBookshelf,
      },
      {
        to: "/subject-group",
        label: "Subject Group",
        icon: mdiBookOpenPageVariant,
      },
      {
        to: "/learning-method",
        label: "Learning Method",
        icon: mdiBookPlusMultiple,
      },
      {
        to: "/grading-aspects",
        label: "Grading Aspects",
        icon: mdiHammerScrewdriver,
      },
        {
        to: "/aspect-academic-year",
        label: "Aspect Academic Year",
        icon: mdiCalendarMonth,
      },
      {
        to: "/aspect-assignment-level",
        label: "Aspect Assignment Level",
        icon: mdiClipboardText,
      },
      {
        to: "/assignment-type",
        label: "Assignment Type",
        icon: mdiFormatListBulletedType,
      },
      {
        to: "/grading-rule",
        label: "Grading Rule",
        icon: mdiFormatLetterMatches,
      },
      {
        to: "/final-score-rule",
        label: "Final Score Rule",
        icon: mdiNumeric9BoxMultiple,
      },
      {
        to: "/scoreminimum",
        label: "Passing Grade",
        icon: mdiNumeric9BoxMultiple,
      },
      {
        to: "/syllabus",
        label: "Syllabus",
        icon: mdiNotebookEdit,
      },
      {
        to: "/teaching-time-plan",
        label: "Teaching Timeplan",
        icon: mdiTimelineClockOutline,
      },
      {
        to: "/lesson-plan",
        label: "Lesson Plan",
        icon: mdiPuzzle,
      },
      {
        to: "/student-paralel-subject",
        label: "Student Parallel Subject",
        icon: mdiAccountDetails,
      },
      {
        to: "/student-select-subject",
        label: "Student Subject Selection",
        icon: mdiAccountDetails,
      },
    ],
  },
  {
    label: "Extracuricular",
    subLabel: "Submenus Extracuricular",
    icon: mdiSoccer,
    menu: [
      {
        to: "/extracuricular",
        label: "Extracuricular",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-group",
        label: "Extracuricular Group",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-student",
        label: "Student Extracuricular",
        icon: mdiAccountDetails,
      },
      {
        to: "/extracuricular-student-select",
        label: "Student Extracuricular Selection",
        icon: mdiAccountDetails,
      },
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ],
  },
  {
    label: "Teacher",
    subLabel: "Submenus Teacher",
    icon: mdiClipboardAccount,
    menu: [
      {
        to: "/teacher",
        label: "Teacher",
        icon: mdiClipboardAccountOutline,
      },
      {
        to: "/teacher-extracuricular",
        label: "Extracurricular Teacher",
        icon: mdiSoccer,
      },
      {
        to: "/teacher-note",
        label: "Teacher Note",
        icon: mdiAccountDetails,
      },
      {
        to: "/scan-asset",
        label: "Scan Asset",
        icon: mdiQrcodeScan,
      },
      {
        to: "/scan-asset-location",
        label: "Scan Asset Location",
        icon: mdiQrcodeScan,
      },
      // {
      // 	to: '/teacherjournal',
      // 	label: 'Teacher Journal',
      // 	icon: mdiFileDocument
      // }
    ],
  },
  {
    label: "Subject Assessment",
    subLabel: "Submenus Subject Assessment",
    icon: mdiSchool,
    menu: [
      {
        to: "/lesson-assessment-regular",
        label: "Regular",
        icon: mdiSchool,
      },
      {
        to: "/lesson-assessment-parallel",
        label: "Parallel",
        icon: mdiSchool,
      },
      {
        to: '/ledger-homeroom-attidude',
        label: 'Homeroom Ledger Attidude',
        icon: mdiSchool
      },
      {
        to: "/ledger-homeroom-teacher",
        label: "Homeroom Ledger",
        icon: mdiSchool,
      },
      {
        to: "/extracuricular-score",
        label: "Extracuricular Score",
        icon: mdiSchool,
      },
    ],
  },
  {
    label: 'Raport',
    to: '/student-raport',
    icon: mdiSchool
  },
];
export default menuHeadMaster;
